import { render, staticRenderFns } from "./yzjd.vue?vue&type=template&id=32f88b5a&scoped=true&"
import script from "./yzjd.vue?vue&type=script&lang=js&"
export * from "./yzjd.vue?vue&type=script&lang=js&"
import style0 from "./yzjd.vue?vue&type=style&index=0&id=32f88b5a&lang=stylus&scoped=true&"
import style1 from "./yzjd.vue?vue&type=style&index=1&id=32f88b5a&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f88b5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32f88b5a')) {
      api.createRecord('32f88b5a', component.options)
    } else {
      api.reload('32f88b5a', component.options)
    }
    module.hot.accept("./yzjd.vue?vue&type=template&id=32f88b5a&scoped=true&", function () {
      api.rerender('32f88b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/mapDrawer/yzjd.vue"
export default component.exports